
const setList = ({ commit }, schedule) => {
  commit('SET_LIST', schedule)
}

const setAvailableAppointments = ({ commit }, schedule) => {
  commit('SET_AVAILABLEAPPOINTMENTS', schedule)
}

export default {
  setList,
  setAvailableAppointments
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/actions.js